<template>
  <section id="editions" class="grant-section">

    <div class="block block-white intro-block">
      <v-container>
        <div class="chapter-eyebrow">
          <span class="ch-label">{{ $t('grants.completed.eyebrow') }}</span>
          <span class="ch-meta">{{ $t('grants.completed.labels.meta_location') }}</span>
        </div>

        <div class="intro-stack">
          <h2>{{ $t('grants.completed.title') }}</h2>
          <p class="lead">{{ $t('grants.completed.lead') }}</p>
        </div>
      </v-container>

      <figure class="hero-photo">
        <img
          src="@/assets/img/components/projects/celka_hydro.webp"
          alt="Celka na hydroskrzydłach"
        />
        <v-container>
          <figcaption>
            <span class="cap-num">Fig. 01</span>
            <span class="cap-text">{{ $t('grants.completed.labels.fig01') }}</span>
          </figcaption>
        </v-container>
      </figure>
    </div>

    <div class="block block-cream">
      <v-container>
        <div class="chapter-eyebrow">
          <span class="ch-label">{{ $t('grants.completed.labels.results') }}</span>
          <span class="ch-meta">{{ $t('grants.completed.labels.results_meta') }}</span>
        </div>

        <div class="intro-grid">
          <h2>{{ $t('grants.completed.labels.results_title') }}</h2>
        </div>

        <div class="results-grid">
          <article v-for="(r, i) in results" :key="r.tagKey" class="result-card">
            <h3 class="r-tag">{{ $t(`grants.completed.labels.result_tags.${r.tagKey}`) }}</h3>
            <p class="r-text">{{ $t(`grants.completed.results.${i + 1}`) }}</p>
          </article>
        </div>
      </v-container>
    </div>

    <div class="block block-white">
      <v-container>
        <div class="chapter-eyebrow">
          <span class="ch-label">{{ $t('grants.completed.labels.realization') }}</span>
          <span class="ch-meta">{{ $t('grants.completed.labels.realization_meta') }}</span>
        </div>

        <div class="content-with-photo">
          <div class="text-col">
            <h2>{{ $t('grants.completed.realization.title') }}</h2>
            <p class="lead">{{ $t('grants.completed.realization.intro') }}</p>

            <div class="narrative">
              <p
                v-for="(phase, i) in phases"
                :key="phase.tagKey"
              >
                <strong>{{ $t(`grants.completed.labels.phase_tags.${phase.tagKey}`) }}.</strong>
                {{ $t(`grants.completed.realization.activities.${i + 1}`) }}
              </p>
              <p class="narrative-summary">
                {{ $t('grants.completed.realization.summary') }}
              </p>
            </div>
          </div>

          <figure class="photo-col">
            <img
              src="@/assets/img/components/projects/celka_hydro2.webp"
              alt="Celka na hydroskrzydłach"
            />
            <figcaption>
              <span class="cap-num">Fig. 02</span>
              <span class="cap-text">{{ $t('grants.completed.labels.fig02') }}</span>
            </figcaption>
          </figure>
        </div>
      </v-container>
    </div>

    <div class="block block-cream">
      <v-container>
        <div class="chapter-eyebrow">
          <span class="ch-label">{{ $t('grants.completed.labels.dissemination') }}</span>
          <span class="ch-meta">{{ $t('grants.completed.labels.dissemination_meta') }}</span>
        </div>

        <div class="content-with-photo mirrored">
          <figure class="photo-col">
            <img
              src="@/assets/img/components/competitions/monako/20220709_AGHSolarBoatMonacoEnergyBoatChallenge_SJanaczek_030.webp"
              alt="Monaco"
              class="photo-ksaf"
            />
            <figcaption>
              <span class="cap-num">Fig. 03</span>
              <span class="cap-text">{{ $t('grants.completed.labels.fig03') }}</span>
            </figcaption>
          </figure>

          <div class="text-col">
            <h2>{{ $t('grants.completed.dissemination.title') }}</h2>
            <p class="lead">{{ $t('grants.completed.dissemination.intro') }}</p>

            <div class="narrative">
              <p
                v-for="(ch, i) in channels"
                :key="ch.tagKey"
              >
                <strong>{{ $t(`grants.completed.labels.channel_tags.${ch.tagKey}`) }}.</strong>
                {{ $t(`grants.completed.dissemination.${i + 1}`) }}
              </p>
            </div>
          </div>
        </div>
      </v-container>
    </div>

  </section>
</template>

<script>
export default {
  name: 'CompletedProjectSection',
  data() {
    return {
      results: [
        { tagKey: 'mechanics' },
        { tagKey: 'electronics' },
        { tagKey: 'control' },
        { tagKey: 'effect' }
      ],
      phases: [
        { tagKey: 'design' },
        { tagKey: 'mechanism' },
        { tagKey: 'electronics' },
        { tagKey: 'composites' },
        { tagKey: 'integration' }
      ],
      channels: [
        { tagKey: 'conferences' },
        { tagKey: 'social' },
        { tagKey: 'competitions' }
      ]
    }
  }
}
</script>

<style lang="sass" scoped>
  .grant-section
    color: #0a0828
    position: relative

  .block
    padding: 130px 0

  .block-cream
    background: #faf7f1

  .block-white
    background: #ffffff

  .chapter-eyebrow
    display: flex
    align-items: baseline
    gap: 32px
    margin-bottom: 56px

    .ch-label
      font-family: Inter, sans-serif
      font-weight: 700
      font-size: 0.78em
      letter-spacing: 0.22em
      text-transform: uppercase
      color: #0a0828

    .ch-meta
      font-family: Inter, sans-serif
      font-weight: 500
      font-size: 0.78em
      letter-spacing: 0.16em
      text-transform: uppercase
      color: #5b637e
      margin-left: auto

  .intro-stack
    max-width: 1100px
    margin-bottom: 0

    h2
      font-family: Raleway, sans-serif
      font-weight: 900
      font-size: 5em
      line-height: 0.92
      letter-spacing: -0.045em
      text-transform: uppercase
      color: #0a0828
      margin: 0 0 40px
      max-width: 900px

    .lead
      font-family: Inter, sans-serif
      font-weight: 400
      font-size: 1.18em
      line-height: 1.75em
      color: #2a2750
      margin: 0
      max-width: 640px

  .intro-grid
    margin-bottom: 80px

    h2
      font-family: Raleway, sans-serif
      font-weight: 900
      font-size: 6em
      line-height: 0.9
      letter-spacing: -0.045em
      text-transform: uppercase
      color: #0a0828
      margin: 0

  .hero-photo
    margin: 100px 0 0
    padding: 0
    position: relative

    > img
      width: 100%
      aspect-ratio: 16 / 8
      max-height: 820px
      min-height: 540px
      object-fit: cover
      object-position: center
      display: block

    figcaption
      display: flex
      align-items: baseline
      gap: 24px
      padding: 22px 0 0
      font-family: Inter, sans-serif

      .cap-num
        font-weight: 700
        font-size: 0.78em
        letter-spacing: 0.22em
        text-transform: uppercase
        color: #0a0828
        flex-shrink: 0

      .cap-text
        font-weight: 500
        font-size: 0.85em
        letter-spacing: 0.04em
        color: #5b637e

  .results-grid
    display: grid
    grid-template-columns: repeat(2, 1fr)
    gap: 70px 100px

  .result-card
    .r-tag
      font-family: Inter, sans-serif
      font-weight: 700
      font-size: 0.85em
      letter-spacing: 0.22em
      text-transform: uppercase
      color: #0a0828
      margin: 0 0 22px
      padding-bottom: 22px
      border-bottom: 1px solid rgba(10, 8, 40, 0.18)

    .r-text
      font-family: Inter, sans-serif
      font-size: 1em
      line-height: 1.7em
      color: #2a2750
      margin: 0

  .content-with-photo
    display: grid
    grid-template-columns: 1.15fr 1fr
    gap: 90px
    align-items: start

    &.mirrored
      grid-template-columns: 1fr 1.15fr

  .text-col
    h2
      font-family: Raleway, sans-serif
      font-weight: 900
      font-size: 5.2em
      line-height: 0.9
      letter-spacing: -0.045em
      text-transform: uppercase
      color: #0a0828
      margin: 0 0 36px

    .lead
      font-family: Inter, sans-serif
      font-weight: 400
      font-size: 1.05em
      line-height: 1.75em
      color: #5b637e
      margin: 0 0 56px
      max-width: 560px

  .narrative
    p
      font-family: Inter, sans-serif
      font-size: 1.02em
      line-height: 1.85em
      color: #2a2750
      margin: 0 0 24px

    strong
      font-family: Inter, sans-serif
      font-weight: 800
      color: #0a0828
      margin-right: 6px

    .narrative-summary
      margin-top: 30px
      font-style: italic
      color: #5b637e

  .photo-col
    margin: 0
    padding: 0
    position: sticky
    top: 100px

    img
      width: 100%
      max-width: 100%
      aspect-ratio: 4 / 5
      object-fit: cover
      display: block
      filter: contrast(1.02) saturate(1.05)

    figcaption
      display: flex
      align-items: baseline
      gap: 16px
      padding: 18px 2px 0
      font-family: Inter, sans-serif

      .cap-num
        font-weight: 700
        font-size: 0.72em
        letter-spacing: 0.22em
        text-transform: uppercase
        color: #0a0828
        flex-shrink: 0

      .cap-text
        font-weight: 500
        font-size: 0.78em
        letter-spacing: 0.04em
        color: #5b637e

  @media only screen and (max-width: 1180px)
    .intro-stack h2
      font-size: 3.8em

    .intro-grid h2
      font-size: 4.6em

    .text-col h2
      font-size: 4em

  @media only screen and (max-width: 900px)
    .block
      padding: 90px 0

    .chapter-eyebrow
      gap: 14px
      margin-bottom: 36px
      flex-wrap: wrap

      .ch-label, .ch-meta
        font-size: 0.7em
        letter-spacing: 0.18em

      .ch-meta
        margin-left: 0
        width: 100%

    .intro-stack
      h2
        font-size: 2.6em
        letter-spacing: -0.035em
        margin-bottom: 24px

      .lead
        font-size: 1.05em

    .intro-grid
      margin-bottom: 50px

      h2
        font-size: 2.8em
        letter-spacing: -0.035em

    .hero-photo
      margin-top: 60px

      > img
        min-height: 0
        max-height: min(52vw, 320px)
        aspect-ratio: 16 / 10

      figcaption
        flex-direction: column
        gap: 6px
        padding-top: 16px

    .results-grid
      grid-template-columns: 1fr
      gap: 50px

    .content-with-photo
      grid-template-columns: 1fr
      gap: 50px

      &.mirrored
        grid-template-columns: 1fr

        .photo-col
          order: 2

        .text-col
          order: 1

    .text-col
      h2
        font-size: 2.6em
        letter-spacing: -0.035em
        margin-bottom: 24px

      .lead
        margin-bottom: 36px

    .narrative
      p
        font-size: 1em
        line-height: 1.8em

    .photo-col
      position: static

      img
        max-height: min(85vw, 480px)
        aspect-ratio: 4 / 5
</style>
